import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: ()=>import('@/views/Home'),
    redirect:'index',
    children:[
       {
         path:'/index',
         name:'index',
         component:()=>import('@/views/main/')
       },
       {
         path:'/register',
         name:'register',
         component:()=>import('@/views/main/register')
       },
       {
        path:'/login',
        name:'login',
        component:()=>import('@/views/main/login')
       },
       {
         path:'/user',
         name:'user',
         component:()=>import('@/views/user/')
       },
       {
         path:'/quetaHome',
         name:'quetaHome',
         component:()=>import('@/views/quetaHome/')
       },
       {
        path:'/quetaDetail',
        name:'quetaDetail',
        component:()=>import('@/views/quetaHome/quetaDetail.vue')
       },
       {
        path:'/biddingHome',
        name:'biddingHome',
        component:()=>import('@/views/biddingHome/')
       },
       {
         path:'/biddingDetail',
         name:'biddingDetail',
         component:()=>import('@/views/biddingHome/biddingDetail')
       },
       {
         path:'/analysis',
         name:'analysis',
         component:()=>import('@/views/itemAnalysis/')
       },
       {
         path:'/news',
         name:'news',
         component:()=>import('@/views/news/') 
       },
       {
        path:'/notice',
        name:'notice',
        component:()=>import('@/views/notice/')
      },
       {
        path:'/details',
        name:'details',
        component:()=>import('@/views/news/details.vue')
       },
       {
        path:'/supplyhome',
        name:'supplyhome',
        component:()=>import('@/views/supplyHome/')
       },
       {
         path:'/supplyDetails',
         name:'supplyDetails',
         component:()=>import('@/views/supplyHome/supplyDetails.vue')
       },
       {
        path:'/industrialService',
        name:'industrialService',
        component:()=>import('@/views/industrialService/')
       },
       {
        path:'/aboutUs',
        name:'aboutUs',
        component:()=>import('@/views/aboutUs/')
       },
       {
        path:'/SellerCentral',  //我要出让
        name:'SellerCentral',
        component:()=>import('@/views/SellerCentral/'),
        redirect:'/seller-manage',
        children:[
           {
            path:'/seller-manage',
            name:'seller-manage',
            component:()=>import('@/views/SellerCentral/secondMenu/seller-manage.vue')
           },
           {
            path:'/seller-gq',
            name:'seller-gq',
            component:()=>import('@/views/SellerCentral/seller-gq/seller-gq.vue')
           },
           //项目挂牌
           {
             path:'/quetation',
             name:'quetation',
             component:()=>import('@/views/SellerCentral/quetation/index.vue')
           },
           //项目挂牌订单
           {
              path:'/quetationOrder',
              name:'quetationOrder',
              component:()=>import('@/views/SellerCentral/quetationOrder/index.vue')
            },
            //项目竞价
            {
              path:'/bidding',
              name:'bidding',
              component:()=>import('@/views/SellerCentral/bidding/bidding.vue')
            },
            //竞价订单列表
            {
              path:'/seItemOrder',
              name:'seItemOrder',
              component:()=>import('@/views/SellerCentral/seItemOrder/')
            },
            //我的合同
            {
              path:'/sellerContract',
              name:'sellerContract',
              component:()=>import('@/views/SellerCentral/sellerContract/')
            },
            {
              path:'/complainResult',
              name:'complainResult',
              component:()=>import('@/views/SellerCentral/complainResult/')
            }
        ]
       },
       {
        path:'/BuyerCenter',  //我要投资
        name:'BuyerCenter',
        component:()=>import('@/views/BuyerCenter/'),
        redirect:'/buyer-manage',
        children:[
          {
            path:'/buyer-manage',
            name:'buyer-manage',
            component:()=>import('@/views/BuyerCenter/secondMenu/buyer-manage.vue')
           },
           //项目挂牌
           {
            path:'/buyer-gp',
            name:'buyer-gp',
            component:()=>import('@/views/BuyerCenter/buyer-gp/')
           },
           //项目竞价已报名
           {       
              path:'/bidded',
              name:'bidded',
              component:()=>import('@/views/BuyerCenter/bidded/')
           },
           //项目竞价已报名管理
           {
            path:'/biddedManege',
            name:'biddedManege',
            component:()=>import('@/views/BuyerCenter/biddedManege/')
           },
           //项目竞价订单列表
           {
            path:'/itemOrder',
            name:'itemOrder',
            component:()=>import('@/views/BuyerCenter/itemOrder/')
           },
           //我的合同
           {
             path:'/buyerContract',
             name:'buyerContract',
             component:()=>import('@/views/BuyerCenter/buyerContract/')
           },
           {
            path:'/buyerComplain',
            name:'buyerComplain',
            component:()=>import('@/views/BuyerCenter/buyerComplain/')
          }
        ]
       },
    ]
  }
];

const router = new VueRouter({
  routes,
  mode:'hash'
});


export default router;
